import React from "react";
import { Trans } from "@lingui/react/macro";
import { Link } from "react-router";
import { PRIVACY_URL } from "@Src/constants/";

const TermsAgreement = () => {
  return (
    <div className="t-body-small SignUpWizard-terms">
      <Trans>
        By clicking Sign Up I agree to the{" "}
        <Link
          to="/terms"
          target="_blank"
          className="SignUp-agreement_link t-label-med"
          rel="noopener noreferrer"
        >
          terms
        </Link>{" "}
        and{" "}
        <a
          href={PRIVACY_URL}
          target="_blank"
          className="SignUp-agreement_link t-label-med"
          rel="noopener noreferrer"
        >
          privacy policy
        </a>
        .
      </Trans>
    </div>
  );
};

export default TermsAgreement;
